class BrokerageSettings {
  issqnPercentage?: number;
}

export default BrokerageSettings;
